import { FC, ReactNode } from 'react';
import { Button, Form } from 'rsuite';
import { RsBasicRaio } from 'components/Rsuite/Radio';
import styles from './autoKeyword.module.scss';

interface DataType {
  value: string;
  label: ReactNode;
}

interface AutoKeywordProps {
  data: DataType[];
  autoMode: string;
  onChange: (v: string) => void;
}

export const AutoKeyword: FC<AutoKeywordProps> = ({
  data,
  autoMode,
  onChange,
}) => {
  return (
    <>
      <Form.HelpText className=''>
        <ul className='pl-[20px]'>
          <li>
            系統根據您擬定的投放策略，自動出價與選字；請避免於兩周內更改，以優化至最佳結果
          </li>
          <li>
            投入產出比會依市場情況浮動，每次進入編輯頁面時，系統會顯示最新預估數值，點選
            <Button
              appearance='primary'
              size='xs'
              onClick={() => {}}
              className='pointer-events-none mx-2 mb-2'
            >
              完成
            </Button>
            按鈕，活動即會適用最新投入產出比目標
          </li>
        </ul>
      </Form.HelpText>
      <div className={styles.AutoChoiceRadio}>
        <RsBasicRaio data={data} selected={autoMode} onChange={onChange} />
        <Form.HelpText className='ml-4 !text-sm'>
          投入產出比設定僅供參考，若設定過高可能導致廣告投放落後，最終成效以實際執行為準
        </Form.HelpText>
      </div>
    </>
  );
};
